import * as React from 'react';
import './styles.sass';

export interface ISessionSwapRolesButtonProps {
  swapRoles: () => void;
}

export const SessionSwapRolesButton: React.StatelessComponent<ISessionSwapRolesButtonProps>
  = ({swapRoles}: ISessionSwapRolesButtonProps) => (
    <button
      className={'btn btn_violet session-swap-roles-button'}
      onClick={swapRoles}
    >
      <span className={'icon fa fa-exchange'} />
      <span className={'btn__label btn__label_left-blank'}>Swap Roles</span>
    </button>
  );
